import Plyr from "plyr"

const PlayVideo = () => {
    const player = new Plyr('#player');


    let players = document.querySelectorAll('.video-player');

    if(players.length)
    {
        players.forEach((player) => {
            let plyPlayer = new Plyr(player, {
                'ratio': '16:9',
            });
        });
    }
}
export default PlayVideo;